import { Shimmer } from '@components/Shimmer'
import { YStack, Stack } from 'tamagui'

export function BannerGhostLoading() {
  return (
    <>
      <Stack flexDirection="column" marginTop={60}>
        <YStack>
          <Shimmer
            width="100%"
            height={300}
            $gtSm={{ height: 480 }}
            $gtLg={{ height: 600 }}
          />
        </YStack>
      </Stack>
    </>
  )
}
